import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui'
import store from './store'
Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', redirect: '/login' },
    {
      path: '/login', name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ './pages/login.vue'),
      meta: { auth: false, name: '登录页' }
    },
    {
      path: '/main', name: 'Main',
      component: () => import(/* webpackChunkName: "main" */ './pages/index.vue'),
      meta: { auth: true, name: '首页' },
      children: [
        {
          path: '/goods', name: 'GoodsList',
          component: () => import(/* webpackChunkName: "goods" */ './pages/goods/list.vue'),
          meta: { auth: true, name: '产品白名单', activeTopPath: 1, activePath: '/goods' }
        },
        {
          path: '/product-certificate', name: 'ProductCertificate',
          component: () => import(/* webpackChunkName: "product-certificate" */ './pages/goods/certificate.vue'),
          meta: { auth: true, name: '产品质量证书管理', activeTopPath: 1, activePath: '/product-certificate' }
        },
        {
          path: '/product-certificate-file', name: 'ProductCertificateFile',
          component: () => import(/* webpackChunkName: "product-certificatecertificate-file" */ './pages/goods/certificate-file.vue'),
          meta: { auth: true, name: '产品质量证书文件管理', activeTopPath: 1, activePath: '/product-certificate' }
        },
        {
          path: '/member-vendors', name: 'member-vendors',
          component: () => import(/* webpackChunkName: "member-vendors" */ './pages/vendors/member-vendors.vue'),
          meta: { auth: true, name: '合作企业', activeTopPath: 1, activePath: '/member-vendors' }
        },
        {
          path: '/member-vendor-detail', name: 'member-vendor-detail',
          component: () => import(/* webpackChunkName: "member-vendor-detail" */ './pages/vendors/member-vendor-detail'),
          meta: { auth: true, name: '合作企业详情', activeTopPath: 1, activePath: '/member-vendors' }
        },
        {
          path: '/users', name: 'users',
          component: () => import(/* webpackChunkName: "users" */ './pages/users/user-list.vue'),
          meta: { auth: true, name: '用户管理', activeTopPath: 1, activePath: '/users' }
        },
        {
          path: '/certificate', name: 'certificate',
          component: () => import(/* webpackChunkName: "certificate" */ './pages/vendors/vendor-certificate/certificate.vue'),
          meta: { auth: true, name: '资质证书列表', activeTopPath: 1, activePath: '/member-vendors' }
        },
        {
          path: '/certificate-file', name: 'certificate-file',
          component: () => import(/* webpackChunkName: "certificate-file" */ './pages/vendors/vendor-certificate/certificate-file.vue'),
          meta: { auth: true, name: '资质证书文件', activeTopPath: 1, activePath: '/member-vendors' }
        },
        {
          path: '/wxapp-portal', name: 'WxappPortalList',
          component: () => import(/* webpackChunkName: "wxapp-portal" */ './pages/wxapp-portal/index.vue'),
          meta: { auth: true, name: '小程序首页', activeTopPath: 1, activePath: '/wxapp-portal' }
        },
        {
          path: '/wxapp-portal-edit', name: 'wxapp-portal-edit',
          component: () => import(/* webpackChunkName: "wxapp-portal-edit" */ './pages/wxapp-portal/edit'),
          meta: { auth: true, name: '小程序首页维护', activeTopPath: 1, activePath: '/wxapp-portal' }
        },
        {
          path: '/wxapp-message', name: 'WxappMessageIndex',
          component: () => import(/* webpackChunkName: "wxapp-message" */ './pages/wxapp-message/index.vue'),
          meta: { auth: true, name: '内容维护', activeTopPath: 1, activePath: '/wxapp-message' }
        },
        {
          path: '/wxapp-message-edit', name: 'wxapp-message-edit',
          component: () => import(/* webpackChunkName: "wxapp-message-edit" */ './pages/wxapp-message/edit'),
          meta: { auth: true, name: '内容维护管理', activeTopPath: 1, activePath: '/wxapp-message' }
        },
        {
          path: '/wxapp-serv', name: 'wxapp-serv',
          component: () => import(/* webpackChunkName: "wxapp-categorys" */ './pages/categorys/service.vue'),
          meta: { auth: true, name: '合作服务', activeTopPath: 1, activePath: '/wxapp-serv' }
        },
        {
          path: '/wxapp-servorg', name: 'service-servorg',
          component: () => import(/* webpackChunkName: "service-servorg" */ './pages/categorys/service-org.vue'),
          meta: { auth: true, name: '合作机构', activeTopPath: 1, activePath: '/wxapp-servorg' }
        },
        {
          path: '/experts', name: 'ExpertsList',
          component: () => import(/* webpackChunkName: "experts" */ './pages/experts/list.vue'),
          meta: { auth: true, name: '人员白名单', activeTopPath: 1, activePath: '/experts' }
        },
        {
          path: '/requirements', name: 'requirements',
          component: () => import(/* webpackChunkName: "requirements" */ './pages/requirements/index'),
          meta: { auth: true, name: '需求管理', activeTopPath: 1, activePath: '/requirements' }
        },
        {
          path: '/info', name: 'InfoList',
          component: () => import(/* webpackChunkName: "info" */ './pages/news/list.vue'),
          meta: { auth: true, name: '政策资讯', activeTopPath: 1, activePath: '/info' }
        },
        {
          path: '/address-book', name: 'address-book',
          component: () => import(/* webpackChunkName: "address-book" */ './pages/address-book/index'),
          meta: { auth: true, name: '电子名片', activeTopPath: 1, activePath: '/address-book' }
        },
        {
          path: '/accounts', name: 'accounts',
          component: () => import(/* webpackChunkName: "accounts" */ './pages/accounts/index'),
          meta: { auth: true, name: '账户管理', activeTopPath: 1, activePath: '/accounts' }
        },
        {
          path: '/settings', name: 'settings',
          component: () => import(/* webpackChunkName: "settings" */ './pages/settings/index.vue'),
          meta: { auth: true, name: '设置', activeTopPath: 1, activePath: '/settings' }
        },
        {
          path: '/disputes', name: 'DisputesList',
          component: () => import(/* webpackChunkName: "disputes" */ './pages/disputes/disputes-list.vue'),
          meta: { auth: true, name: '金盾调解', activeTopPath: 1, activePath: '/disputes' }
        },
        {
          path: '/verification-corps', name: 'VerificationCorps',
          component: () => import(/* webpackChunkName: "verification-corps" */ './pages/verification/corp/index.vue'),
          meta: { auth: true, name: '核验机构', activeTopPath: 1, activePath: '/verification-corps' }
        },
        {
          path: '/exam-question', name: 'ExamQuestion',
          component: () => import(/* webpackChunkName: "exam-question" */ './pages/verification/question/index.vue'),
          meta: { auth: true, name: '核验题库', activeTopPath: 1, activePath: '/exam-question' }
        },
        {
          path: '/verifications', name: 'VerificationList',
          component: () => import(/* webpackChunkName: "verifications" */ './pages/verification/history/index.vue'),
          meta: { auth: true, name: '核验记录', activeTopPath: 1, activePath: '/verifications' }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const userInfo = store.state.account.userInfo
  if (to.meta.auth && !userInfo.token) {
    Message({ message: '请先登录', type: 'error', duration: 1000 })
    setTimeout(() => {
      next({ path: '/login' })
    }, 1000)
  } else {
    next()
  }
})

router.afterEach(() => {})

export default router
